module.exports = __webpack_public_path__ + "img/fulufuxi_logo.09322ac0.png";